<template>
  <b-overlay
    id="overlay-background"
    :show="currencySettingLoader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="5"
        lg="5"
        offset-lg="3"
        class="fields-container"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <!-- form -->
            <b-form>
              <validation-observer
                ref="settingsform"
                tag="form"
              >
                <b-row>
                  <b-col sm="12">

                    <validation-provider
                      #default="{ errors }"
                      name="Invoice Client"
                      rules="required"
                    >
                      <b-form-group
                        label="Invoice Client"
                        label-for="module"
                      >
                        <v-select
                          v-model="invoiceClient"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="clientsData"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="currencysettings"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Invoice Case Group"
                      rules="required"
                    >
                      <b-form-group
                        label="Invoice Case Group"
                        label-for="module"
                      >
                        <v-select
                          v-model="invoiceCaseGroup"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="casesData"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="currencysettings"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Invoice Template"
                      rules="required"
                    >
                      <b-form-group
                        label="Invoice Template"
                        label-for="module"
                      >
                        <v-select
                          v-model="invoiceTemplate"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="lettersData"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="currencysettings"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Invoice Email Template"
                      rules="required"
                    >
                      <b-form-group
                        label="Invoice Email Template"
                        label-for="module"
                      >
                        <v-select
                          v-model="invoiceEmailTemplate"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="emailTemplatesOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="currencysettings"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC Journal ID"
                      rules="required"
                    >
                      <b-form-group
                        label="BC Journal ID"
                        label-for="module"
                      >
                        <b-form-input
                          v-model="bcJournalId"
                          type="text"
                          input-id="bcJournalId"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="BC Journal Batch Name"
                      rules="required"
                    >
                      <b-form-group
                        label="BC Journal Batch Name"
                        label-for="module"
                      >
                        <b-form-input
                          v-model="bcJournalBatchName"
                          type="text"
                          input-id="bcJournalBatchName"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
              </validation-observer>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                block
                variant="primary"
                @click="postCurrencySettingValues"
              >
                Save
              </b-button>
            </b-form>
            <!--/ form -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BOverlay, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import constants from '@/app-configs/constants'
import { required } from '@validations'
import axios from '@axios'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
    BButton,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currencySettingLoader: false,
      invoiceClient: null,
      required,
      invoiceCaseGroup: null,
      invoiceTemplate: null,
      currencyOptions: [
        { label: 'DKK', value: 'DKK' },
        { label: 'EURO', value: 'EUR' },
      ],
      clientsData: [],
      casesData: [],
      lettersData: [],
      caseClientId: null,
      caseSecret: null,
      lettersClientId: null,
      lettersSecret: null,
      emailTemplatesOptions: [],
      invoiceEmailTemplate: null,
      communicationClientId: null,
      communicationSecret: null,
      bcJournalId: null,
      bcJournalBatchName: null,
    }
  },
  watch: {
    settings: {
      handler() {
        this.mapValues()
      },
    },
    // role: {
    //   handler(selected) {
    //     this.settingsData(selected)
    //   },
    // },
  },
  created() {
    this.caseCredentials()
    this.lettersCredentials()
    this.communicationCredentials()
    // this.mapValues()
  },
  methods: {
    async caseCredentials() {
      axios.get('user-settings/get', { params: { module: 'debt-cases' } }).then(response => {
        // const settingValues = this.setting_values
        const settingDetails = response.data.data
        if (settingDetails === null) {
          this.caseClientId = ''
          this.caseSecret = ''
        } else {
          this.caseClientId = settingDetails.client_id
          this.caseSecret = settingDetails.secret
          this.caseGroupsData()
          this.clientData()
        }
      })
    },
    async lettersCredentials() {
      axios.get('user-settings/get', { params: { module: 'physical-letters' } }).then(response => {
        // const settingValues = this.setting_values
        const settingDetails = response.data.data
        if (settingDetails === null) {
          this.lettersClientId = ''
          this.lettersSecret = ''
        } else {
          this.lettersClientId = settingDetails.client_id
          this.lettersSecret = settingDetails.secret
          this.getlettersData()
        }
      })
    },
    async communicationCredentials() {
      axios.get('user-settings/get', { params: { module: 'communication' } }).then(response => {
        // const settingValues = this.setting_values
        const settingDetails = response.data.data
        if (settingDetails === null) {
          this.communicationClientId = ''
          this.communicationSecret = ''
        } else {
          this.communicationClientId = settingDetails.client_id
          this.communicationSecret = settingDetails.secret
          this.getEmailTemplates()
        }
      })
    },
    async caseGroupsData() {
      this.loader = true
      await axios.get(`${constants.caseServerBaseUrl}debtiaapp/debt-case-groups-dropdown`, {
        headers: {
          secret: this.caseSecret,
          clientId: this.caseClientId,
        },
      }).then(response => {
        if (response.status) {
          this.casesData = response.data.data
        }
      })
    },
    async clientData() {
      this.loader = true
      await axios.get(`${constants.caseServerBaseUrl}debtiaapp/clients/dropdown`, {
        headers: {
          secret: this.caseSecret,
          clientId: this.caseClientId,
        },
      }).then(response => {
        if (response.status) {
          this.clientsData = response.data.data
          // console.log('response.data.data is ', typeof response.data.data)
        }
      })
    },
    async getlettersData() {
      this.loader = true
      await axios.get(`${constants.lettersServerApiBaseUrl}/list-all-letters?dropdown=true`, {
        headers: {
          secret: this.lettersSecret,
          clientId: this.lettersClientId,
        },
      }).then(response => {
        if (response.status) {
          this.lettersData = response.data.data
          // console.log('response.data.data is ', typeof response.data.data)
        }
      })
    },
    async getEmailTemplates() {
      const headers = {
        clientId: this.communicationClientId,
        secret: this.communicationSecret,
      }
      await axios.get(`${constants.communicationServerApiV1BaseUrl}/email/get-templates`, { headers }).then(settings => {
        if (settings.status) {
          this.template = settings.data.data
          for (let i = 0; i < this.template.length; i += 1) {
            const obj = {
              label: this.template[i].name,
              value: this.template[i].id,
            }
            this.emailTemplatesOptions.push(obj)
          }
        }
      }).catch(error => {
        this.makeFailureToast(error)
      })
    },
    mapValues() {
      const itemCase = this.settings.filter(word => word.key === 'debtia_invoice_group_id')
      if (itemCase.length > 0) {
        this.invoiceCaseGroup = itemCase[0].value && (Number(itemCase[0].value) > 0) ? Number(itemCase[0].value) : null
      }
      const itemClient = this.settings.filter(word => word.key === 'debtia_invoice_client_id')
      if (itemClient.length > 0) {
        this.invoiceClient = itemClient[0].value && (Number(itemClient[0].value) > 0) ? Number(itemClient[0].value) : null
      }
      const itemTemplate = this.settings.filter(word => word.key === 'debtia_invoice_template_id')
      if (itemTemplate.length > 0) {
        this.invoiceTemplate = itemTemplate[0].value && (Number(itemTemplate[0].value) > 0) ? Number(itemTemplate[0].value) : null
      }
      const itemEmailTemplate = this.settings.filter(word => word.key === 'debtia_invoice_email_template_id')
      if (itemEmailTemplate.length > 0) {
        this.invoiceEmailTemplate = itemEmailTemplate[0].value && (Number(itemEmailTemplate[0].value) > 0) ? Number(itemEmailTemplate[0].value) : null
      }
      const itemBCJournalId = this.settings.filter(word => word.key === 'bc_journal_id')
      if (itemBCJournalId.length > 0) {
        this.bcJournalId = itemBCJournalId[0].value
      }
      const itemBCJournalBatchName = this.settings.filter(word => word.key === 'bc_journal_batch_name')
      if (itemBCJournalBatchName.length > 0) {
        this.bcJournalBatchName = itemBCJournalBatchName[0].value
      }
    },
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.currencySettingLoader = false
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
    postCurrencySettingValues() {
      return new Promise((resolve, reject) => {
        this.$refs.settingsform.validate().then(success => {
          if (success) {
            this.currencySettingLoader = true
            const obj = [
              {
                key: 'debtia_invoice_group_id',
                value: this.invoiceCaseGroup,
              },
              {
                key: 'debtia_invoice_client_id',
                value: this.invoiceClient,
              },
              {
                key: 'debtia_invoice_template_id',
                value: this.invoiceTemplate,
              },
              {
                key: 'debtia_invoice_email_template_id',
                value: this.invoiceEmailTemplate,
              },
              {
                key: 'bc_journal_id',
                value: this.bcJournalId,
              },
              {
                key: 'bc_journal_batch_name',
                value: this.bcJournalBatchName,
              },
            ]
            axios.post('payment/user-settings/save', obj).then(response => {
              if (response.status) {
              // localStorage.setItem('defaultCurrency', this.currencyselected)
                this.currencySettingLoader = false
                this.makeSuccessToast()
              }
            }).catch(error => {
            // if (err.response.data.message) {
            //   this.alertErrors.push(err.response.data.message)
            // }
              this.makeFailureToast(error)
            })
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .fields-container {
    border: 2px solid #f8f8f8;
    border-radius: 10px;
  }
  </style>
